import { EventTypes } from "modules/orders-manage/models/order-events";
import { CommonBusinessEventProps } from "./common";

export const OrderWorkStartedBusinessEvent = (props: CommonBusinessEventProps) => null;

OrderWorkStartedBusinessEvent.TYPE = EventTypes.OrderWorkStartedBusinessEvent;
